import {useEffect, useRef} from 'react'
import Hls from 'hls.js'
import {SxProps} from '@mui/system'
import {Box} from '@mui/material'

export const CameraVideoPlayer = ({
								 src,
								 sx
							 }: {
	src: string
	sx?: SxProps
}) => {
	const videoRef = useRef<HTMLVideoElement>(null)
	
	useEffect(() => {
		const video = videoRef.current
		if (!video) return
		
		if (Hls.isSupported()) {
			const hls = new Hls({
				lowLatencyMode: true,
			})
			
			hls.loadSource(src)
			hls.attachMedia(video)
			
			hls.on(Hls.Events.ERROR, (event, data) => {
				console.error('HLS error', data)
			})
			
			return () => hls.destroy()
		}
		
		if (video.canPlayType('application/vnd.apple.mpegurl')) {
			video.src = src
		}
	}, [src])
	
	return (
		<Box
			component={'video'}
			ref={videoRef}
			controls
			autoPlay
			muted
			playsInline
			sx={sx}
		/>
	)
}